module.exports = __webpack_public_path__ + "4276eaa6dbd71f42c5212f78dd63d72b.png";